export default "__VITE_ASSET__Dof6DaM___"